/**
 * AppFooter — Footer global EkynAir (mini-sprint A bis D98+D99, refactor
 * helper buildInfo D100).
 *
 * Mention copyright + version applicative en clair sur une ligne unique.
 * Le hash de build sort du texte visible et s'expose via tooltip natif
 * `title` sur l'élément <footer> (Build {BUILD_HASH}).
 *
 * Source des chaînes : helper `shared/buildInfo.js` (D100). Le composant
 * ne lit plus `process.env` directement — la lecture est centralisée
 * dans le helper, consommé aussi par les 4 pages auth qui partagent le
 * même wording marque + version + tooltip hash.
 *
 * Variants (D95) :
 *   - 'owner' (défaut) : 1 ligne — "EkynAir by Ekynea © 2026 · v{VERSION}"
 *   - 'vet'            : 2 lignes — ligne 1 idem owner, ligne 2 grisée
 *                        "Mode Pro Vétérinaire V1.0"
 *
 * Props :
 *   - darkMode : boolean. Pilote la palette (bordure, fond, texte).
 *   - variant  : 'owner' (défaut) ou 'vet'.
 */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { mainLine, tooltipTitle } from './buildInfo';

const baseStyle = (darkMode) => ({
  textAlign: 'center',
  padding: '20px',
  borderTop: darkMode ? '1px solid rgba(77, 198, 255, 0.2)' : '1px solid #e0e0e0',
  backgroundColor: darkMode ? '#1E1E32' : '#f8f9fa',
  color: darkMode ? '#E8EDF2' : '#4A5568',
  fontSize: '14px',
  fontFamily: "'Inter', sans-serif",
});

const sublineStyle = (darkMode) => ({
  display: 'block',
  marginTop: '4px',
  fontSize: '11px',
  opacity: 0.65,
  color: darkMode ? '#A8B4C0' : '#6B7280',
  letterSpacing: '0.02em',
});

// `mainLine` (marque « EkynAir by Ekynea © 2026 · v{VERSION} ») reste identique
// FR/EN — marque + version, partagée avec les 4 pages auth via buildInfo, non
// traduite. Seule la sous-ligne véto est de la prose localisée (footer.vetMode).
const AppFooter = ({ darkMode = false, variant = 'owner' }) => {
  const { t } = useTranslation();
  return (
    <footer
      style={baseStyle(darkMode)}
      data-testid="app-footer"
      title={tooltipTitle}
    >
      <span>{mainLine}</span>
      {variant === 'vet' && (
        <span
          style={sublineStyle(darkMode)}
          data-testid="app-footer-vet-subline"
        >
          {t('footer.vetMode')}
        </span>
      )}
    </footer>
  );
};

export default AppFooter;
